import { render, staticRenderFns } from "./BasicButtonGroup.vue?vue&type=template&id=fd0a00f6"
import script from "./BasicButtonGroup.vue?vue&type=script&lang=js"
export * from "./BasicButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports